import React, { useState, useEffect, useContext } from 'react'

import { FiltersContext } from 'client/components/FiltersContainer/context'
import Checkbox from 'src/comps/Checkbox'

import { FilterRatingsBase, Title, List } from './styles'

import { useS4LContext } from '@s4l/react-context'

const availableRatings = ['9', '8', '7', '6'] as const

const FilterRatings = () => {
  const { i18n } = useS4LContext()
  const { filters, setFilters } = useContext(FiltersContext)
  const [selected, setSelected] = useState<string[]>([])

  useEffect(() => {
    setSelected(filters.ratings || [])
  }, [filters.ratings])

  function handleClick(rating: string) {
    const index = selected.indexOf(rating)
    const ratingExists = index > -1
    const filteredRatings = ratingExists
      ? selected.filter((f, i) => i !== index)
      : [...selected, rating]

    setFilters({ ...filters, ratings: filteredRatings })
  }

  const rattingMessages = {
    9: i18n.formatMessage({ id: 'score.range-1' }),
    8: i18n.formatMessage({ id: 'score.range-2' }),
    7: i18n.formatMessage({ id: 'score.range-3' }),
    6: i18n.formatMessage({ id: 'score.range-4' }),
  } as const

  return (
    <FilterRatingsBase>
      <Title>{i18n.formatMessage({ id: 'global.guest-rating' })}</Title>

      <List>
        {availableRatings.map(rating => {
          const isSelected = !!selected.find(r => r === rating)

          return (
            <li key={`rating-${rating}`}>
              <Checkbox
                label={
                  <>
                    {rattingMessages[rating]}
                    {`: ${rating}+`}
                  </>
                }
                name={`rating-${rating}`}
                onChange={() => handleClick(rating)}
                selected={isSelected}
              />
            </li>
          )
        })}
      </List>
    </FilterRatingsBase>
  )
}

export default FilterRatings
